// ================================================================
// Dunning API — Mahnungen erzeugen/senden (fällige Kandidaten + Versand)
// ================================================================
// Eigene Datei statt org.js weiter zu füllen: eigene Routen (/api/dunning/*),
// eigene Domäne. saveDunning() (Settings-Formular) bleibt vorerst in org.js.
import { getToken } from './auth.js';
import { apiRequest, readErrorMessage } from './apiClient.js';

export function fetchDunningCandidates() {
  return apiRequest('/api/dunning/candidates');
}

export function sendDunning(documentId, payload) {
  return apiRequest('/api/dunning/' + encodeURIComponent(documentId) + '/send', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

// Blob-Preview (gleiches Muster wie viewDocumentPdf in core/documents.js — die
// Route braucht den Bearer-Token, ein simpler <a href> reicht nicht).
export async function viewDunningEventPdf(eventId) {
  const token = getToken();
  const res = await fetch('/api/dunning/events/' + encodeURIComponent(eventId) + '/pdf', {
    headers: { ...(token ? { Authorization: 'Bearer ' + token } : {}) },
  });
  if (!res.ok) {
    let body = {};
    try { body = await res.json(); } catch { /* binäre Antwort ohne JSON-Body */ }
    const err = new Error(readErrorMessage(body, res.status));
    err.status = res.status;
    throw err;
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob); // call-site muss revokeObjectURL aufrufen
}
